/**
 * @file WithCMMSOverview.jsx
 * @description 설비보전관리시스템(CMMS) 소개 페이지입니다.
 */

export default function WithCMMSOverview() {
  return (
    <>
      {/* ============== HERO ============== */}
      <section className="hero" style={{ paddingTop: '72px' }}>
        <div className="container hero-inner">
          <div>
            <span className="section-eyebrow">Computerized Maintenance Management System</span>
            <h1>
              설비를 관리하는<br />
              가장 단순한 방법.
              <span className="sys">Computerized Maintenance Management System</span>
            </h1>
            <p className="lead">
              설비 점검·고장수리·예비부품·실시간 모니터링·알람·KPI·AI 예지보전을
              하나의 시스템에서 다룹니다.
            </p>

            <div className="hero-stats">
              <div className="hero-stat">
                <div className="num">7</div>
                <div className="lbl">주요 업무 영역</div>
              </div>
              <div className="hero-stat">
                <div className="num">2</div>
                <div className="lbl">관리 / 모바일 UI</div>
              </div>
              <div className="hero-stat">
                <div className="num">AI</div>
                <div className="lbl">예지보전 분석</div>
              </div>
            </div>
          </div>

          {/* Dashboard mock */}
          <div className="preview" aria-hidden="true">
            <div className="preview-bar">
              <span className="preview-dot"></span><span className="preview-dot"></span><span className="preview-dot"></span>
              <span className="preview-url">withCMMS · 대시보드 / 청주공장</span>
            </div>
            <div style={{ padding: 0, background: '#fafbfd' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 18px', background: 'white', borderBottom: '1px solid #eef1f7' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ width: '22px', height: '22px', borderRadius: '6px', background: 'var(--green)', display: 'grid', placeItems: 'center', color: 'white', fontWeight: 800, fontSize: '10px' }}>C</div>
                  <div style={{ fontSize: '13px', fontWeight: 700 }}>withCMMS <span style={{ color: 'var(--muted)', fontWeight: 500 }}>/ 대시보드</span></div>
                </div>
                <div style={{ fontSize: '11px', color: 'var(--muted)' }}>2026.05.21 · 관리자[admin]</div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '10px', padding: '14px', background: '#fafbfd' }}>
                <div className="kpi-tile" style={{ padding: '12px' }}>
                  <div className="label">MTBF</div>
                  <div className="val" style={{ fontSize: '22px' }}>428<span className="unit">h</span></div>
                  <div className="sub" style={{ color: 'var(--green-2)' }}>목표 400h 달성</div>
                </div>
                <div className="kpi-tile" style={{ padding: '12px' }}>
                  <div className="label">MTTR</div>
                  <div className="val" style={{ fontSize: '22px' }}>2.4<span className="unit">h</span></div>
                  <div className="sub">전 주 대비 ↓0.6h</div>
                </div>
                <div className="kpi-tile" style={{ padding: '12px' }}>
                  <div className="label">진행중 점검</div>
                  <div className="val" style={{ fontSize: '22px' }}>12<span className="unit">건</span></div>
                  <div className="sub">대기 4 / 진행 8</div>
                </div>
                <div className="kpi-tile" style={{ padding: '12px' }}>
                  <div className="label">미해결 고장</div>
                  <div className="val" style={{ fontSize: '22px', color: 'var(--red)' }}>3<span className="unit" style={{ color: 'var(--red)' }}>건</span></div>
                  <div className="sub">신규 1 · 진행 2</div>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1.3fr 1fr', gap: '10px', padding: '0 14px 14px' }}>
                <div className="kpi-tile" style={{ padding: '14px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <div style={{ fontSize: '12px', fontWeight: 700 }}>점검 진행 추이 (최근 1주)</div>
                    <div style={{ fontSize: '10px', color: 'var(--muted)' }}>전체 / 완료</div>
                  </div>
                  <svg width="100%" height="120" viewBox="0 0 320 120" style={{ marginTop: '8px' }}>
                    <g fontFamily="inherit" fontSize="9" fill="#8a96ac">
                      <text x="0" y="115">04-15</text>
                      <text x="48" y="115">04-16</text>
                      <text x="96" y="115">04-17</text>
                      <text x="144" y="115">04-18</text>
                      <text x="192" y="115">04-19</text>
                      <text x="240" y="115">04-20</text>
                      <text x="288" y="115">04-21</text>
                    </g>
                    <g>
                      {[
                        { x: 2,   y: 44, h: 58, fill: '#1f3478' },
                        { x: 18,  y: 56, h: 46, fill: '#1c8de4' },
                        { x: 50,  y: 32, h: 70, fill: '#1f3478' },
                        { x: 66,  y: 50, h: 52, fill: '#1c8de4' },
                        { x: 98,  y: 40, h: 62, fill: '#1f3478' },
                        { x: 114, y: 58, h: 44, fill: '#1c8de4' },
                        { x: 146, y: 24, h: 78, fill: '#1f3478' },
                        { x: 162, y: 38, h: 64, fill: '#1c8de4' },
                        { x: 194, y: 36, h: 66, fill: '#1f3478' },
                        { x: 210, y: 54, h: 48, fill: '#1c8de4' },
                        { x: 242, y: 28, h: 74, fill: '#1f3478' },
                        { x: 258, y: 42, h: 60, fill: '#1c8de4' },
                        { x: 290, y: 48, h: 54, fill: '#1f3478' },
                        { x: 306, y: 64, h: 38, fill: '#1c8de4' },
                      ].map((b, i) => (
                        <rect
                          key={b.x}
                          x={b.x} y={b.y} width="14" height={b.h} fill={b.fill} rx="2"
                          className="cmms-hero-bar"
                          style={{ animationDelay: `${i * 50}ms` }}
                        />
                      ))}
                    </g>
                  </svg>
                </div>
                <div className="kpi-tile" style={{ padding: '14px' }}>
                  <div style={{ fontSize: '12px', fontWeight: 700, marginBottom: '8px' }}>고장 알람</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {[
                      { bg: '#fde9e7', color: 'var(--red)',         text: 'CB3000 진동이상',     time: '2분 전' },
                      { bg: '#fdf2dd', color: 'var(--amber-2)',     text: 'DR1200 온도 경고',     time: '12분 전' },
                      { bg: '#e9f2fc', color: 'var(--blue-2)',      text: 'MX700 점검 알림',     time: '1시간 전' },
                      { bg: 'var(--bg-soft)', color: 'var(--text)', text: 'PK4100 정기점검 예정', time: '내일' },
                    ].map((a) => (
                      <div key={a.text} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', padding: '6px 8px', background: a.bg, borderRadius: '6px' }}>
                        <span style={{ fontWeight: 600, color: a.color }}>{a.text}</span>
                        <span style={{ color: 'var(--muted)' }}>{a.time}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============== FEATURES ============== */}
      <section className="section" id="features">
        <div className="container">
          <div className="section-head">
            <span className="section-eyebrow">Key Features</span>
            <h2>설비보전 업무 전 과정을<br />한 시스템에서.</h2>
            <p>점검·수리·자재·계측·알람·KPI·예지보전 — 설비 이이에 필요한 업무를 하나의 절차로 묶었습니다.</p>
          </div>

          <div className="grid-3">
            {[
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 11h6m-6 4h6M7 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="m9.5 7.5 1 1 2.5-2.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
                color: 'green', title: '설비 정기점검',
                desc: '설비별 일상·정기 점검 주기를 등록하고, 지정된 일정에 따라 점검 결과를 기록합니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="m14.7 6.3 3 3-9.4 9.4-3.3.3.3-3.3 9.4-9.4Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="m13 8 3 3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
                color: 'green', title: '설비 고장수리',
                desc: '고장이 발생하면 수리 지시를 등록하고, 수리 결과를 입력해 이력으로 남깁니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 7h18v12H3z" stroke="currentColor" strokeWidth="1.8"/><path d="M3 7l3-4h12l3 4M12 7v12M3 12h18" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/></svg>,
                color: 'green', title: '예비부품 관리',
                desc: '예비부품의 입고 및 출고, 재고의 입출 현황을 한 곳에서 관리합니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 12h4l3-7 4 14 3-7h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
                color: '', title: '실시간 모니터링',
                desc: '설비의 계측 데이터를 수집해 현황화면에 실시간으로 보여 줍니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M6 8a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M10 18a2 2 0 1 0 4 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
                color: '', title: '설비 알람',
                desc: '임계치를 벗어나는 계측 값이 발생하면 사용자에게 자동 통지합니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M4 20V10m6 10V4m6 16v-8m6 8v-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
                color: 'navy', title: '설비 KPI',
                desc: '고장수리 이력을 바탕으로 MTBF·MTTR을 계산해 기간별로 조회합니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8"/><path d="M12 3v3m0 12v3M3 12h3m12 0h3M5.6 5.6l2 2m8.8 8.8 2 2M5.6 18.4l2-2m8.8-8.8 2-2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
                color: 'navy', title: 'AI 예지보전',
                desc: '계측 데이터와 고장 이력을 학습해 설비의 변화를 감지하고 수명을 예측합니다.',
              },
              {
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M7 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.8"/><path d="M9 8h6M9 12h6M9 16h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
                color: 'navy', title: '기준정보',
                desc: '설비 마스터·예비부품 BOM·KPI 기준을 한 곳에서 관리합니다.',
              },
            ].map((f) => (
              <div key={f.title} className="feature">
                <div className={`icon${f.color ? ` ${f.color}` : ''}`}>{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============== MOBILE ============== */}
      <section className="section soft">
        <div className="container split">
          <div>
            <span className="section-eyebrow">Admin UI + Mobile UI</span>
            <h3 style={{ marginTop: '14px' }}>현장에서 바로 처리하는 보전 업무.</h3>
            <p>관리자의 데스크탑 뿐 아니라, 점검과 수리를 수행하는 작업자가 사용하는 모바일 UI를 함께 제공합니다. 설비 바코드 라벨을 스캔하면 입력 대상 설비를 자동으로 식별합니다.</p>
            <ul className="bullets green">
              <li>설비점검 결과 입력</li>
              <li>고장수리 결과 입력</li>
              <li>예비부품 입고 / 출고 검색</li>
              <li>설비 바코드 라벨 스캔</li>
            </ul>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: '280px', background: '#0e1d4d', borderRadius: '36px', padding: '10px', boxShadow: 'var(--shadow-lg)' }}>
              <div style={{ background: 'white', borderRadius: '28px', overflow: 'hidden' }}>
                <div style={{ background: 'var(--green)', color: 'white', padding: '14px 16px', fontSize: '13px', fontWeight: 700, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>설비 고장수리</span>
                  <span style={{ fontSize: '10px', fontWeight: 500, opacity: '.8' }}>CB3000</span>
                </div>
                <div style={{ padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <div>
                    <div style={{ fontSize: '10px', color: 'var(--muted)', letterSpacing: '.04em' }}>설비명</div>
                    <div style={{ fontSize: '13px', fontWeight: 700 }}>정제 혼합실 · 칭량기 CB3000</div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                    <div>
                      <div style={{ fontSize: '10px', color: 'var(--muted)' }}>고장유형</div>
                      <div style={{ fontSize: '12.5px', fontWeight: 600 }}>진동 이과</div>
                    </div>
                    <div>
                      <div style={{ fontSize: '10px', color: 'var(--muted)' }}>조치</div>
                      <div style={{ fontSize: '12.5px', fontWeight: 600 }}>베어링 교체</div>
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '10px', color: 'var(--muted)' }}>사용 부품</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '4px', padding: '8px 10px', background: 'var(--green-soft)', borderRadius: '8px', fontSize: '12px' }}>
                      <span style={{ fontWeight: 700, color: 'var(--green-2)' }}>SP-BR-2210</span>
                      <span style={{ color: 'var(--muted)', marginLeft: 'auto' }}>×1</span>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '6px', alignItems: 'center', background: 'var(--bg-soft)', padding: '8px 10px', borderRadius: '8px', fontSize: '11px', color: 'var(--muted)' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><rect x="3" y="6" width="2" height="12" fill="currentColor"/><rect x="6" y="6" width="1" height="12" fill="currentColor"/><rect x="8" y="6" width="2" height="12" fill="currentColor"/><rect x="11" y="6" width="1" height="12" fill="currentColor"/><rect x="13" y="6" width="3" height="12" fill="currentColor"/><rect x="17" y="6" width="1" height="12" fill="currentColor"/><rect x="19" y="6" width="2" height="12" fill="currentColor"/></svg>
                    바코드로 부품 확인 완료
                  </div>
                  <button style={{ border: 'none', background: 'var(--navy)', color: 'white', padding: '10px', borderRadius: '8px', fontWeight: 700, fontSize: '13px' }}>수리 완료 등록</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============== KPI ============== */}
      <section className="section">
        <div className="container">
          <div className="section-head">
            <span className="section-eyebrow">KPI · Predictive Maintenance</span>
            <h2>표준 KPI와 AI 분석을<br />같은 데이터 위에서.</h2>
            <p>같은 고장수리 이력과 계측 데이터를 기반으로 MTBF/MTTR과 AI 변화감지·수명분석을 함께 제공합니다.</p>
          </div>

          <div className="grid-2" style={{ gap: '20px' }}>
            <div className="arch" style={{ padding: '24px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '14px' }}>
                <div>
                  <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '.06em', color: 'var(--muted)', textTransform: 'uppercase' }}>설비 KPI</div>
                  <div style={{ fontSize: '18px', fontWeight: 700, marginTop: '2px' }}>MTBF · MTTR</div>
                </div>
              </div>

              <div className="grid-2" style={{ gap: '12px' }}>
                <div className="kpi-tile">
                  <div className="label">MTBF — 고장 사이 평균 시간</div>
                  <div className="val">428<span className="unit">h</span></div>
                  <div className="sub">높을수록 좋음 · 목표 400h</div>
                </div>
                <div className="kpi-tile">
                  <div className="label">MTTR — 복구 평균 시간</div>
                  <div className="val">2.4<span className="unit">h</span></div>
                  <div className="sub">낮을수록 좋음 · 목표 3.0h</div>
                </div>
              </div>

              <table className="table" style={{ marginTop: '16px' }}>
                <thead><tr><th>설비</th><th>MTBF</th><th>MTTR</th><th className="right">고장 건수</th></tr></thead>
                <tbody>
                  <tr><td>CB3000 칭량기</td><td className="mono">412h</td><td className="mono">2.1h</td><td className="right">3</td></tr>
                  <tr><td>DR1200 건조기</td><td className="mono">488h</td><td className="mono">3.0h</td><td className="right">2</td></tr>
                  <tr><td>MX700 혼합기</td><td className="mono">356h</td><td className="mono">1.8h</td><td className="right">4</td></tr>
                  <tr><td>PK4100 포장기</td><td className="mono">512h</td><td className="mono">2.5h</td><td className="right">2</td></tr>
                </tbody>
              </table>
            </div>

            <div className="arch" style={{ padding: '24px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '14px' }}>
                <div>
                  <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '.06em', color: 'var(--muted)', textTransform: 'uppercase' }}>AI 분석</div>
                  <div style={{ fontSize: '18px', fontWeight: 700, marginTop: '2px' }}>변화감지 · 수명분석</div>
                </div>
              </div>

              <div style={{ background: 'var(--bg-soft)', borderRadius: '10px', padding: '14px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: 'var(--muted)', marginBottom: '6px' }}>
                  <span>CB3000 진동 (mm/s) · 30일</span>
                  <span>
                    <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', background: 'var(--blue)', marginRight: '4px' }}></span>실측
                    <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', background: 'var(--amber)', margin: '0 4px 0 8px' }}></span>이상 추이
                  </span>
                </div>
                <svg width="100%" height="120" viewBox="0 0 400 120" preserveAspectRatio="none">
                  <defs>
                    <linearGradient id="aiGrad" x1="0" x2="0" y1="0" y2="1">
                      <stop offset="0%" stopColor="#1c8de4" stopOpacity=".25" />
                      <stop offset="100%" stopColor="#1c8de4" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                  <path d="M0 80 L 20 76 L 40 82 L 60 78 L 80 72 L 100 78 L 120 70 L 140 76 L 160 72 L 180 68 L 200 64 L 220 62 L 240 56 L 260 50 L 280 44 L 300 38 L 320 30 L 340 24 L 360 20 L 380 14 L 400 8 L 400 120 L 0 120 Z" fill="url(#aiGrad)" />
                  <path d="M0 80 L 20 76 L 40 82 L 60 78 L 80 72 L 100 78 L 120 70 L 140 76 L 160 72 L 180 68 L 200 64 L 220 62 L 240 56 L 260 50 L 280 44 L 300 38 L 320 30 L 340 24 L 360 20 L 380 14 L 400 8" stroke="#1c8de4" strokeWidth="2" fill="none" strokeLinecap="round" />
                  <line x1="0" y1="36" x2="400" y2="36" stroke="#d92d20" strokeWidth="1" strokeDasharray="4 4" />
                  <text x="6" y="30" fontSize="9" fill="#d92d20">임계치</text>
                  <circle cx="300" cy="38" r="4" fill="#d97706" />
                  <circle cx="340" cy="24" r="4" fill="#d97706" />
                  <circle cx="380" cy="14" r="4" fill="#d97706" />
                </svg>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginTop: '14px' }}>
                <div style={{ padding: '12px', border: '1px solid var(--line)', borderRadius: '10px' }}>
                  <div style={{ fontSize: '11px', color: 'var(--muted)' }}>설비 변화감지</div>
                  <div style={{ fontSize: '13px', fontWeight: 700, marginTop: '4px' }}>CB3000 · 18일 후<br />임계치 도달 추정</div>
                </div>
                <div style={{ padding: '12px', border: '1px solid var(--line)', borderRadius: '10px' }}>
                  <div style={{ fontSize: '11px', color: 'var(--muted)' }}>설비 수명분석</div>
                  <div style={{ fontSize: '13px', fontWeight: 700, marginTop: '4px' }}>베어링 잔여수명<br />약 42일</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
